module.exports = __webpack_public_path__ + "img/es-pc-s5.842cd1b7.png";